module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/icon_title_6-dd6127b0ca9346a7967deb5b19fa27cf.svg";